import './main.scss';
import { IFramePlayerComponent } from '@opten/gin-tonic/components/player/component';
import { factory } from '@opten/gin-tonic/helpers/compiler';
import { CollapseComponent } from './components/collapse/component';
import { HighlightComponent } from './utility/highlight/highlight';
import { TabsComponent } from '@opten/gin-tonic/components/tabs/component';
import { HeroComponent } from './components/hero/component';
import { NavVisibilityComponent } from '@opten/gin-tonic/components/nav-visibility/component';
import { StickyComponent } from '@opten/gin-tonic/components/sticky';
import { HamburgerComponent } from '@opten/gin-tonic/components/hamburger/component';
import { SelectComponent } from '@opten/gin-tonic/components/select/component';
import { FormFieldComponent } from '@opten/gin-tonic/components/form-field/component';
import { MixitComponent } from '@opten/gin-tonic/components/mixitup/component';
import { CookiebotRenewComponent } from '@opten/gin-tonic/components/cookiebot';
import { MapExtendedComponent } from './components/map';
import { GalleryComponent } from './components/gallery/gallery';
import { SwiperComponent } from '@opten/gin-tonic/components/swiper/component';
import { NewsSliderComponent } from './components/news-slider/sliders';
import { DialogComponent } from './components/dialog';
import { FilterComponent } from './components/filter/component';
import { CounterComponent } from './components/fact/component';
import { MasonryComponent } from './components/masonry';
import { BackToTopComponent } from './components/back-to-top';
import { StickyServicesTitleComponent } from './components/services/sticky-title';

factory([
	CollapseComponent,
	CounterComponent,
	DialogComponent,
	FilterComponent,
	FormFieldComponent,
	GalleryComponent,
	MapExtendedComponent,
	HamburgerComponent,
	HeroComponent,
	HighlightComponent,
	IFramePlayerComponent,
	SelectComponent,
	StickyComponent,
	StickyServicesTitleComponent,
	SwiperComponent,
	TabsComponent,
	MixitComponent,
	NavVisibilityComponent,
	NewsSliderComponent,
	MasonryComponent,
	BackToTopComponent,
	CookiebotRenewComponent
])(document.body);
